import React from "react";
import { useContent } from "@/context/ContentContext";
import SEO from "@/components/SEO";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Journal from "@/components/site/Journal";

export default function JournalPage() {
  const content = useContent();
  const j = content?.journal;
  return (
    <div className="bg-background min-h-screen">
      <SEO
        title="Journal — Nat Habitat"
        description={j?.body || "Explore our process, materials and stories from inside the studio."}
        path="/journal"
        image={content?.seo?.og_image}
      />
      <Nav brand={content?.brand?.name} />
      {/* clearance for the fixed header */}
      <div className="pt-20 md:pt-24" />
      <Journal data={j} />
      <Footer content={content} />
    </div>
  );
}
